var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-wrappper" },
    [
      _c("div", { staticClass: "row m-0 manager-container" }, [
        _c("div", { staticClass: "row mb-25 mt-25 ml-15 mr-15" }, [
          _c(
            "div",
            { staticClass: "col-lg-8 col-md-7 col-sm-6 col-xs-12" },
            [
              _c(
                "router-link",
                {
                  staticClass: "sub-heading",
                  attrs: { to: "/layout/launchpad" },
                },
                [
                  _c("i", { staticClass: "fa fa-angle-left" }),
                  _vm._v("Project Manager Team Access "),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-lg-4 col-md-5 col-sm-6 col-xs-12 xs-mt-20" },
            [
              _c("search-box", {
                on: { getList: _vm.getListBySearchName },
                model: {
                  value: _vm.searchText,
                  callback: function ($$v) {
                    _vm.searchText = $$v
                  },
                  expression: "searchText",
                },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "row m-0" }, [
          _c("div", { staticClass: "col-xs-12 p-0" }, [
            _c("div", { staticClass: "first_table" }, [
              _c("table", { staticClass: "table activity-tracker-table" }, [
                _c("thead", [
                  _c(
                    "tr",
                    [
                      _c("th", { staticClass: "filter-th wd-65 sticky" }),
                      _c(
                        "th",
                        { staticClass: "wd-65 shadow_col sticky-checkbox" },
                        [
                          _vm.filteredList && _vm.filteredList.length
                            ? _c("span", { staticClass: "checkbox" }, [
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectAllManagers,
                                        expression: "selectAllManagers",
                                      },
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      disabled: _vm.filteredList.length < 2,
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.selectAllManagers
                                      )
                                        ? _vm._i(_vm.selectAllManagers, null) >
                                          -1
                                        : _vm.selectAllManagers,
                                    },
                                    on: {
                                      change: [
                                        function ($event) {
                                          var $$a = _vm.selectAllManagers,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.selectAllManagers =
                                                  $$a.concat([$$v]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.selectAllManagers = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.selectAllManagers = $$c
                                          }
                                        },
                                        function ($event) {
                                          return _vm.selectAll()
                                        },
                                      ],
                                    },
                                  }),
                                  _c("span", { staticClass: "cr" }),
                                ]),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _vm._l(_vm.headers, function (header) {
                        return _c("th", { key: header.key }, [
                          _vm._v(" " + _vm._s(header.name)),
                          _c(
                            "span",
                            {
                              staticClass: "sort",
                              class:
                                _vm.sortOrders[header.key] > 0 ? "asc" : "desc",
                              on: {
                                click: function ($event) {
                                  return _vm.sortBy(header.key)
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: "/static/images/icons/sortDesc.svg",
                                },
                              }),
                            ]
                          ),
                        ])
                      }),
                    ],
                    2
                  ),
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.filteredList, function (projectManager, index) {
                    return _c(
                      "tr",
                      { key: index },
                      [
                        _c("td", { staticClass: "menu-td sticky" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "dropdown dropdown-export export-activity-menu text-center",
                              attrs: { id: "trackerActionDots" + index },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: { "margin-top": "1px" },
                                  attrs: { "data-toggle": "dropdown" },
                                  on: { click: _vm.menuDropdown },
                                },
                                [_vm._m(0, true)]
                              ),
                              _c(
                                "ul",
                                {
                                  staticClass:
                                    "activitytrackermenu dropdown-menu export-menu",
                                  class: _vm.changeClass ? "addReverse" : "",
                                },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "light",
                                        content:
                                          "Admin users cannot be converted as REP PM.",
                                        placement: "top-start",
                                        disabled: !projectManager.is_admin,
                                      },
                                    },
                                    [
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              projectManager.is_admin
                                                ? null
                                                : _vm.openConvertPMtoREP(
                                                    projectManager
                                                  )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "text-color-blue menu-dots-links",
                                              attrs: {
                                                disabled:
                                                  projectManager.is_admin,
                                              },
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "tracker-images",
                                                attrs: {
                                                  src: "/static/images/icons/convertion_icon.svg",
                                                  alt: "convertion-icon",
                                                },
                                              }),
                                              _c("span", [
                                                _vm._v("Convert to REP PM"),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c("li", { staticClass: "divider" }),
                                  _c(
                                    "li",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.openDeletePopup(
                                            true,
                                            projectManager.user_account_id
                                          )
                                        },
                                      },
                                    },
                                    [_vm._m(1, true)]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                        _c("td", { staticClass: "sticky-checkbox" }, [
                          _c("span", { staticClass: "checkbox" }, [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedManager,
                                    expression: "selectedManager",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  value: projectManager.user_account_id,
                                  checked: Array.isArray(_vm.selectedManager)
                                    ? _vm._i(
                                        _vm.selectedManager,
                                        projectManager.user_account_id
                                      ) > -1
                                    : _vm.selectedManager,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.selectedManager,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = projectManager.user_account_id,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.selectedManager = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.selectedManager = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.selectedManager = $$c
                                    }
                                  },
                                },
                              }),
                              _c("span", { staticClass: "cr" }),
                            ]),
                          ]),
                        ]),
                        _vm._l(_vm.headers, function (header) {
                          return _c(
                            "td",
                            { key: header.key, staticClass: "table-name" },
                            [
                              header.key === "company_name"
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "table-accountname cursor-pointer decoration-underline",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openAccountDetails(
                                            projectManager.account_id
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(projectManager[header.key]))]
                                  )
                                : [_vm._v(_vm._s(projectManager[header.key]))],
                            ],
                            2
                          )
                        }),
                      ],
                      2
                    )
                  }),
                  0
                ),
              ]),
            ]),
            _vm.filteredList && !_vm.filteredList.length
              ? _c("h2", { staticClass: "center" }, [
                  _vm._v(" No Project Manager(s) found "),
                ])
              : _vm._e(),
          ]),
        ]),
        _c("div", { staticClass: "row ml-15 mr-0 mt-35 mb-20" }, [
          _c(
            "div",
            {
              staticClass:
                "col-xs-12 col-sm-offset-6 col-sm-5 col-md-offset-6 col-md-5 col-lg-offset-8 col-lg-3",
            },
            [
              _vm.filteredList && _vm.filteredList.length
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-blue-button",
                      attrs: {
                        type: "button",
                        disabled:
                          _vm.disableButtonForAddTeam ||
                          _vm.loaderStatus ||
                          _vm.selectedManager.length < 2,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.openDeletePopup(false)
                        },
                      },
                    },
                    [_vm._v("Remove Project Manager(s)")]
                  )
                : _vm._e(),
            ]
          ),
        ]),
      ]),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
      _c("convert-pm-to-rep-pm-popup", {
        attrs: { convertUserDetails: _vm.convertUserDetails },
        on: { converted: _vm.getManagersList },
      }),
      _c("common-delete-user-popup", {
        attrs: { convertUserDetails: _vm.convertUserDetails },
        on: {
          deleteConfirmation: function ($event) {
            return _vm.removeManager()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "dropdown-toggle" }, [
      _c("i", { staticClass: "fa fa-ellipsis-v menu-dots" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { staticClass: "text-color-delete-red menu-dots-links" }, [
      _c("img", {
        staticClass: "tracker-images",
        attrs: {
          src: "/static/images/icons/delete_icon.svg",
          alt: "delete-icon",
        },
      }),
      _c("span", [_vm._v("Remove")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }